import { Badge, IconButton, ThemeProvider, useTheme } from '@mui/material'
import {
  CourierInboxListItemActionFactoryProps,
  CourierInboxListItemFactoryProps,
  CourierInboxMenuButtonFactoryProps,
  CourierInboxPopupMenu,
  CourierToast,
} from '@trycourier/courier-react'
import React, { useCallback } from 'react'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { BellOMIcon } from '@omnea-app/icons'

// Full browser nav (not an SPA push) so Courier's cross-origin click-tracking redirect resolves.
const navigateTo = (href: string | undefined) => {
  if (!href) {
    return
  }
  const url = new URL(href, window.location.origin)
  if (url.protocol === 'http:' || url.protocol === 'https:') {
    window.location.assign(url.href)
  }
}

export const NotificationInbox: React.FC = () => {
  const userData = useAuthenticatedUser()
  const theme = useTheme()

  // Courier renders the trigger in a detached root with no theme context, so it gets ours passed in.
  const renderMenuButton = useCallback(
    (props: CourierInboxMenuButtonFactoryProps | null | undefined) => (
      <ThemeProvider theme={theme}>
        <IconButton>
          <Badge
            variant="dot"
            invisible={!props?.totalUnreadCount}
            sx={{ '& .MuiBadge-dot': { bgcolor: 'bg.success.default', outline: '2px solid', outlineColor: 'border.white' } }}
          >
            <BellOMIcon />
          </Badge>
        </IconButton>
      </ThemeProvider>
    ),
    [theme]
  )

  const handleMessageClick = useCallback(
    ({ message }: CourierInboxListItemFactoryProps) => navigateTo(message.actions?.find((action) => action.href)?.href),
    []
  )
  const handleActionClick = useCallback(({ action }: CourierInboxListItemActionFactoryProps) => navigateTo(action.href), [])

  if (userData.isFullyAuthenticated && !userData.user.isSupplier) {
    return (
      <CourierInboxPopupMenu
        mode="light"
        popupAlignment="top-right"
        renderMenuButton={renderMenuButton}
        onMessageClick={handleMessageClick}
        onMessageActionClick={handleActionClick}
      />
    )
  }
  return null
}

export const NotificationToast: React.FC = () => {
  const userData = useAuthenticatedUser()
  if (userData.isFullyAuthenticated && !userData.user.isSupplier) {
    return <CourierToast mode="light" autoDismiss autoDismissTimeoutMs={5000} />
  }
  return null
}
